import { render } from "./AshesTwoView.vue?vue&type=template&id=5d8949cf"
import script from "./AshesTwoView.vue?vue&type=script&lang=js"
export * from "./AshesTwoView.vue?vue&type=script&lang=js"

import "./AshesTwoView.vue?vue&type=style&index=0&id=5d8949cf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__